import '@ezugi/polyfills.js';

import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { isOTTABonURL, isUABonURL } from './util/utils';

import './style';

const AB = lazy(() => import('./configs/config-ab'));
const UAB = lazy(() => import('./configs/config-uab'));
const OTTAB = lazy(() => import('./configs/config-ottab'));

const getGameVariant = () => {
  switch (true) {
  case isOTTABonURL:
    return OTTAB;
  case isUABonURL:
    return UAB;
  default:
    return AB;
  }
};

const rootElement = document.getElementById('root') as HTMLDivElement;
const root = createRoot(rootElement);

const ABGame = getGameVariant();

root.render(
  <Suspense>
    <ABGame />
  </Suspense>
);
